export default __webpack_public_path__ + "static/media/pointshistory.2cde2600.svg";